import React from 'react';
import { IError } from './useRequestState';
import { ErrorText } from '../components/SignupTextField';

const extractErrors = (error: IError): string[] => {
    const errorsObject = error?.response?.data?.errors;
    const errorKeys = Object.keys(errorsObject || {});

    if (errorKeys.length === 0) return [error.message];

    const errorArray: string[] = [];
    errorKeys.forEach((e) => {
        const message = errorsObject[e];
        message && errorArray.push(message);
    });

    return errorArray;
};

const RenderError: React.FC<{ error: IError; className?: string }> = ({
    error,
    className,
}) => {
    const errorArray = extractErrors(error);
    return (
        <div className={className}>
            {errorArray.map((e, i) => (
                <ErrorText key={i} text={e} />
            ))}
        </div>
    );
};

export default RenderError;
